import React, { FC } from 'react'
import { Grid, Box, Icon } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { green } from '@mui/material/colors'
import { icons } from '../../../constants/icons'

const useStyles = makeStyles(() => ({
  wrap: {
    width: ({ width }: MultilineLabelProps) => width,
  },
  itemBlock: {
    width: '215px',
  },
  leftBlock: {
    display: 'inline',
  },
  rightBlock: {
    display: 'inline',
    verticalAlign: 'top',
    paddingLeft: '8px',
  },
  valueStyle: {
    fontSize: '16px',
    color: 'white',
  },
}))

interface MultilineLabelProps {
  dataValues: string[]
  width?: string | number
}

export const MultilineLabel: FC<MultilineLabelProps> = ({ dataValues, width }) => {
  const classes = useStyles({ width, dataValues })

  return (
    <Grid container item xs={12} className={classes.wrap}>
      {dataValues.map((item, index) => {
        return (
          <Grid item xs={12} key={index} className={classes.itemBlock}>
            <Grid item className={classes.leftBlock}>
              <Icon style={{ color: green[500] }}>{icons.DONE}</Icon>
            </Grid>
            <Grid item xs={12} className={classes.rightBlock}>
              <Box component="span" className={classes.valueStyle}>
                {item}
              </Box>
            </Grid>
          </Grid>
        )
      })}
    </Grid>
  )
}
